import React from 'react';
import styled from 'styled-components';
import memberIcon from "../../../assets/svgs/profile_icon.svg"
import { Ptag } from '../../fonts';
import { Logo, TileHeadingText, TileHeading } from './styles';
import { copytoClipBoard, formatDateReverse, formatRelationshipEcard, newDateReverse } from '../../../utils/utils';
import copy from "../../../assets/svgs/copyToClipboard.svg"
import iconx from "../../../assets/svgs/ecard_icon.svg"
import icony from "../../../assets/svgs/ecard_icon_right.svg"
import { CopyContent, TitleDiv, GridBox, MainBox, GridItem,Label, Value, CopyButton  } from './styles';
import { Divider } from '@mui/material';
function ECardHr({ member, tpaName }) {
  return (
    <MainBox>
        <TitleDiv>
            <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <img src={memberIcon} alt='profile'/>
                <TileHeadingText style={{marginBottom: '0px'}}>
                {member.name}
                </TileHeadingText>
            </div>
            <div>
                <Logo src={member.insurer} style={{marginBottom: '0'}}/>
            </div>
        </TitleDiv>
    <GridBox>
      <GridItem>
      <Label>Date of Birth</Label>
          <Value>
            {member && member.dob &&  newDateReverse(member.dob)}
          </Value>
      </GridItem>
      <GridItem>
      <Label>Relationship</Label>
          <Value>
            {member &&
              member["relationship"] &&
              formatRelationshipEcard(member["relationship"])}
          </Value>
      </GridItem>
      <GridItem>
      <Label>Cover Start Date</Label>
          <Value>
            {member &&
              member["policy_start_date"] &&
              formatDateReverse(member["policy_start_date"])}
          </Value>
      </GridItem>
      <GridItem>
      <Label>Cover End Date</Label>
          <Value>
            {member &&
              member["policy_end_date"] &&
              formatDateReverse(member["policy_end_date"])}
          </Value>
      </GridItem>
      </GridBox>
        <div style={{padding:' 0 2rem 1rem 2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    gap:'0.5rem'}}>
            <CopyContent>
                <Label style={{fontSize: '12px'}}>Policy Number</Label>
                <Value style={{fontWeight: 600}}>{member.policy_number}</Value>
                <img src={copy} alt='copy' style={{height: '16px', width: '16px', cursor: 'pointer'}} onClick={()=>copytoClipBoard(member.policy_number)}/>
            </CopyContent>
            <CopyContent>
                <Label style={{fontSize: '12px'}}>Health ID</Label>
                <Value style={{fontWeight: 600}}>{member.client_id || '-'}</Value>
                <img src={copy} alt='copy' style={{height: '16px', width: '16px', cursor: 'pointer'}} onClick={()=>copytoClipBoard(member.client_id)}/>
            </CopyContent>
        </div>
        <div>
        {member.tpa_name &&
        <div>
        <Label  style={{textAlign: 'center', display: 'flex', justifyContent: 'center', paddingTop: '1rem', fontSize: '9px'}}>SERVICE BY</Label>
        <Divider style={{ padding: '0.5rem 1rem 1rem 1rem', display: 'flex', alignItems: 'flex-end', width: '100%', boxSizing: 'border-box' }}>
                <div>
                <Ptag fontSize='12px' fontWeight='500' color='rgba(74, 74, 74, 1)' style={{
                    maxWidth: '100% !important',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                    wordBreak: 'break-word',
                    textAlign: 'center',
                    minWidth: '240px'
                }}>{member.tpa_name}</Ptag>
                </div>
            </Divider>
        </div>}
        {!member.tpa_name && <div style={{paddingBottom: '1rem'}}></div>}
        </div>
        
    </MainBox>
  );
}

export default ECardHr;

